export const _en = {
    activeRecurrence: {
        label: "Enable recurrence"
    },
    recurrencePosition: {
        label: "Occurrence session index"
    },
    recurrenceEach: {
        label: "Repeat all the"
    },
    recurrenceType: {
        label: "Repeat frequency"
    },
    dayOfWeek: {
        label: "Day"
    },
    finishDateRecurrence: {
        label: "Finish date"
    },
    numberOfRecurrence: {
        label: "Occurrences count",
        suffix: "Occurrences"
    }
};

export const _fr = {
    activeRecurrence: {
        label: "Activer la recurrence"
    },
    recurrencePosition: {
        label: "Le n° d’itération de l’activité"
    },
    recurrenceEach: {
        label: "Repéter tout les"
    },
    recurrenceType: {
        label: "Fréquence de répétition"
    },
    dayOfWeek: {
        label: "Jour"
    },
    finishDateRecurrence: {
        label: "Date de fin de la récurrence"
    },
    numberOfRecurrence: {
        label: "Nombre d'occurences",
        suffix: "occurences"
    }
};